import type { EmailValue } from 'components/EmailTo'
import type { BaseFile } from 'config'

export interface INote {
  id: number
  loanNumber: number
  noteBy: string
  content: string
  files: BaseFile[]
  notifiers: EmailValue
  subject: string
  messageId: string | null
  history: string
  from: string
  to: string[]
  isRead: boolean
  createdAt: Date
  updatedAt: Date
}

export enum NotePageType {
  GLOBAL = 'global',
  SERVICING = 'servicing',
  REO = 'reo',
}
